import { render, staticRenderFns } from "./BaseButtonInfo.vue?vue&type=template&id=755a478a&scoped=true&"
var script = {}
import style0 from "./BaseButtonInfo.vue?vue&type=style&index=0&id=755a478a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755a478a",
  null
  
)

export default component.exports